// Mock data for Fichet Serrurerie — serrurier indépendant spécialiste Fichet

export const companyInfo = {
  name: "Fichet Serrurerie",
  shortName: "Fichet Serrurerie",
  tagline: "Votre serrure Fichet mérite un vrai spécialiste",
  description: "Serrurier spécialiste des serrures et portes Fichet depuis plus de 10 ans : ouverture de porte, remplacement de cylindre, dépannage et entretien de portes blindées à Paris et en Île-de-France.",
  phone: "07 46 50 41 13",
  emergencyPhone: "07 46 50 41 13",
  email: "contact@fichet-serrurerie.fr",
  address: "Paris et Île-de-France",
  yearsExperience: 10,
};

export const navigation = [
  { label: "Accueil", path: "/" },
  { label: "Porte blindée", path: "/porte-blindee" },
  { label: "Ouverture de porte", path: "/ouverture-porte" },
  { label: "Remplacement de serrure", path: "/remplacement-serrure" },
  { label: "Dépannage de porte", path: "/depannage-porte" },
  { label: "Dépannage coffre-fort", path: "/depannage-coffre-fort" },
];

export const topBarLinks = [
  { label: "Devis gratuit", path: "/devis" },
  { label: "Dépannage d'urgence", path: "/depannage-porte" },
  { label: "Reproduction de clé", path: "/remplacement-serrure" },
  { label: "Simulateur", path: "/simulateur" },
];

export const heroImages = {
  home: "/technicien-hero.jpg",
  technicienConseil: "/technicien-conseil.jpg",
  technicienUrgence: "/technicien-urgence.jpg",
  porteBlindee: "/porte-blindee.jpg",
  ouverturePorte: "/ouverture-porte.jpg",
  remplacementSerrure: "/remplacement-serrure.jpg",
  depannagePorte: "/depannage-porte.jpg",
  depannageCoffre: "/depannage-coffre-fort.jpg",
  lock1: "/serrure-3-points.jpg",
  lock2: "/serrure-5-points.jpg",
  lock3: "/serrure-7-points.jpg",
  safe1: "https://images.unsplash.com/photo-1710981855156-1dd4b48e668d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxzYWZlJTIwdmF1bHR8ZW58MHx8fHwxNzg3MjUwNjgwfDA&ixlib=rb-4.1.0&q=85",
  safe2: "https://images.unsplash.com/photo-1602503874881-c97c18856ae6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxzYWZlJTIwdmF1bHR8ZW58MHx8fHwxNzg3MjUwNjgwfDA&ixlib=rb-4.1.0&q=85",
  installer: "/reseau-serrures.jpg",
};

export const homeServices = [
  {
    title: "Porte blindée Fichet",
    description: "Entretien, réglage et remise en état de portes blindées Fichet certifiées A2P, pour appartement et maison.",
    image: heroImages.porteBlindee,
    path: "/porte-blindee",
  },
  {
    title: "Ouverture de porte",
    description: "Intervention rapide 24h/24 pour l'ouverture de porte Fichet claquée ou fermée à clé, sans dégât.",
    image: heroImages.ouverturePorte,
    path: "/ouverture-porte",
  },
  {
    title: "Remplacement de serrure",
    description: "Remplacement de serrures haute sécurité 3, 5 et 7 points et de cylindres Fichet.",
    image: heroImages.remplacementSerrure,
    path: "/remplacement-serrure",
  },
  {
    title: "Dépannage de porte",
    description: "Réparation de porte, blocs-portes blindés et menuiseries après tentative d'effraction.",
    image: heroImages.depannagePorte,
    path: "/depannage-porte",
  },
  {
    title: "Dépannage coffre-fort",
    description: "Ouverture et réparation de coffre-fort Fichet-Bauche en cas de perte de clé ou de blocage.",
    image: heroImages.depannageCoffre,
    path: "/depannage-coffre-fort",
  },
];

export const stats = [
  { value: "10", suffix: "+", label: "Ans d'expérience sur la marque Fichet" },
  { value: "30", suffix: "min", label: "Délai moyen d'intervention" },
  { value: "95", suffix: "%", label: "D'ouvertures sans dégât" },
  { value: "24/7", suffix: "", label: "Dépannage d'urgence" },
];

export const advantages = [
  {
    title: "Spécialistes Fichet",
    description: "Des techniciens formés aux systèmes Fichet : serrures multipoints, cylindres brevetés, portes blindées.",
    icon: "ShieldCheck",
  },
  {
    title: "Devis gratuit et transparent",
    description: "Le prix est annoncé clairement avant chaque intervention. Aucune surprise sur la facture.",
    icon: "Users",
  },
  {
    title: "Ouverture sans dégât",
    description: "Nos méthodes d'ouverture fine préservent votre porte et votre serrure dans 95% des cas.",
    icon: "Award",
  },
  {
    title: "Intervention rapide",
    description: "En 30 minutes en moyenne à Paris et en Île-de-France, 7 jours sur 7, jour et nuit.",
    icon: "Clock",
  },
];

export const googleReview = {
  rating: "4,8",
  count: 86,
};

export const testimonials = [
  {
    name: "Marie Dupont",
    location: "Paris 8ème",
    text: "Ma serrure Fichet était complètement bloquée. Le technicien connaissait parfaitement le mécanisme et l'a réparée sans rien abîmer. Je me sens enfin en sécurité chez moi.",
    rating: 5,
  },
  {
    name: "Jean-Pierre Martin",
    location: "Neuilly-sur-Seine",
    text: "Intervention en urgence un dimanche soir après une tentative d'effraction. Le serrurier est arrivé en moins de 45 minutes. Service exceptionnel.",
    rating: 5,
  },
  {
    name: "Sophie Laurent",
    location: "Boulogne-Billancourt",
    text: "Un vrai savoir-faire. Mon cylindre Fichet a été remplacé avec précision et le devis a été respecté au centime. La différence de qualité se sent immédiatement.",
    rating: 5,
  },
];

export const zones = [
  { code: "75", name: "Paris", cities: "Tous les arrondissements, du 1er au 20ème" },
  { code: "92", name: "Hauts-de-Seine", cities: "Boulogne-Billancourt, Neuilly, Levallois, Nanterre..." },
  { code: "93", name: "Seine-Saint-Denis", cities: "Saint-Denis, Montreuil, Bobigny, Pantin..." },
  { code: "94", name: "Val-de-Marne", cities: "Créteil, Vincennes, Saint-Maur, Ivry..." },
  { code: "78", name: "Yvelines", cities: "Versailles, Saint-Germain-en-Laye, Poissy..." },
  { code: "95", name: "Val-d'Oise", cities: "Argenteuil, Cergy, Pontoise, Ermont..." },
  { code: "91", name: "Essonne", cities: "Évry, Massy, Palaiseau, Corbeil..." },
  { code: "77", name: "Seine-et-Marne", cities: "Meaux, Chelles, Melun, Torcy..." },
];

export const porteBlindeeModels = [
  {
    name: "Fichet Forstyl S",
    certification: "A2P BP1",
    features: ["Serrure 3 points", "Isolation phonique 32dB", "Design contemporain"],
    image: heroImages.porteBlindee,
  },
  {
    name: "Fichet Protecta",
    certification: "A2P BP2",
    features: ["Serrure 5 points", "Isolation phonique 40dB", "Habillage sur-mesure"],
    image: heroImages.lock2,
  },
  {
    name: "Fichet Spheris",
    certification: "A2P BP3",
    features: ["Serrure 7 points", "Isolation phonique 45dB", "Blindage renforcé"],
    image: heroImages.lock3,
  },
];

export const emergencySteps = [
  { number: "01", title: "Appelez-nous", description: "Contactez notre service d'urgence disponible 24h/24 et 7j/7" },
  { number: "02", title: "Devis immédiat", description: "Nous vous communiquons un devis clair par téléphone avant l'intervention" },
  { number: "03", title: "Intervention", description: "Un technicien spécialiste des systèmes Fichet intervient rapidement sur place" },
  { number: "04", title: "Résolution", description: "Ouverture sans dégât ou remplacement immédiat selon la situation" },
];
